import { createReducer, on } from "@ngrx/store";
import { ComponentState } from "../../shared/types/ComponentState";
import { AccountInfoActions } from "../actions";
import { TwePopup } from "../../create-request/models/internal-transfer/TwePopup";
import { TransactionFormServiceError } from "../../create-request/models/form/TransactionForm";
import { ApiEndpointType } from "../../shared/utilities/Constants";
import { TransactionFormActions, WireActions } from "../../create-request/actions";
import { StandingAuthAchActions, StandingAuthCheckActions, StandingAuthFormActions, StandingAuthWireActions } from "../../standing-authorizations/actions";

export const editTweModalStateKey = 'editTweModalState';

export interface State extends ComponentState {
  verifyCallFinished: boolean,
  twePopup: TwePopup,
  serviceError: TransactionFormServiceError,
  submitCallFinished: boolean
}

export const initialEditTweServiceError: TransactionFormServiceError = {
  status: 0,
  url: '',
  name: '',
  message: '',
  correlationId: '',
  hasError: false,
}

export const initialEditTweModalState: State = {
  loading: false,
  submitCallFinished: false,
  error: '',
  hasError: false,
  twePopup: {
    openTwePopup: false,
    totalRows: 0,
    isFirstTimeDistribution: false,
    isTweOnFile: false,
    isNonNAState: false,
    existingAccountFederalTaxWithholdingElection: false,
    existingAccountStateTaxWithholdingElection: false,
    existingAccountFedTaxRate: 0,
    existingAccountStateTaxRate: 0,
    fedTaxRateUserEntered: 0,
    stateTaxRateUserEntered: 0,
    accountDetails: {
        aprOverflowIn: false,
        sloaOverflowInd: false,
        recurringOverflowInd: false,
        errorCode: 0,
        totalRowsApr: 0,
        totalRowsSloa: 0,
        totalRowsRecurring: 0,
        hasRecurringTxn: false,
        hasSloaTxn: false,
        cashieringRequestAprs: [],
        recurringRequests: [],
        sloaRequests: [],
        returnCode: '',
        errorMessage: '',
        errorDetails: '',
        accountLevelInfo: {
            trustAccountIndicator: false,
            hasWfpaRoleIndicator: false,
            hasNdfaRoleIndicator: false,
            hasLpfaRoleIndicator: false,
            masterSubAssociationIndicator: false,
            accountRegistrationValidIndicator: false,
            checkRestrictionIndicator: false,
            journalRestrictionIndicator: false,
            moneylinkRestrictionInIndicator: false,
            moneylinkRestrictionOutIndicator: false,
            validBirthDateIndicator: false,
            validTaxpayerIdIndicator: false,
            validRcFrmBptIndicator: false,
            cashMoneyMarketFundAmount: 0,
            availableToBorrowAmount: 0,
            rmdEligibleIndicator: false,
            rmdActiveRecurringIndicator: false,
            customer592Date: '',
            customer702Date: '',
            rmdAnnualCalcAmount: 0,
            rmdAnnualPaidYearToDateAmount: 0,
            rmdAnnualRemainAmount: 0
        },
    },
    regShortName: '',
  },
  verifyCallFinished: false,
  serviceError: initialEditTweServiceError
};

export const reducer = createReducer(
  initialEditTweModalState,
  on(
    AccountInfoActions.verifyTaxWithholdings,
    (state) => {
      return {
        ...state,
        loading: true,
        verifyCallFinished: false
      };
    }
  ),
  on(AccountInfoActions.verifyTaxWithholdingsSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      hasError: false,
      twePopup: response.twePopup,
      verifyCallFinished: true,
      serviceError: initialEditTweServiceError
    };
  }),
  on(AccountInfoActions.verifyTaxWithholdingsFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      hasError: true,
      verifyCallFinished: false,
      serviceError: {
        ...state.serviceError,
        status: err.status,
        url: err.url,
        name: ApiEndpointType.verifyTaxWithholdings,
        message: err.error[0].Detail,
        hasError: !err.ok
      },
    };
  }),
  on(AccountInfoActions.editTweLinkClicked,
    StandingAuthFormActions.loadReviewPage,
    TransactionFormActions.loadReviewPage, (state) => {
    return {
      ...state,
      loading: false,
      error: '',
      hasError: false,
      verifyCallFinished: false,
      serviceError: initialEditTweServiceError
    };
  }),
  on(AccountInfoActions.submitTaxWithholdings, (state) => {
    return {
      ...state,
      submitCallFinished: false,
      loading: true
    };
  }),
  on(AccountInfoActions.submitTaxWithholdingsSuccess, (state) => {
    return {
      ...state,
      submitCallFinished: true,
      loading: false
    };
  }),
  on(AccountInfoActions.submitTaxWithholdingsFailure, (state, err) => {
    return {
      ...state,
      loading: false,
      hasError: true,
      submitCallFinished: false,
      serviceError: {
        ...state.serviceError,
        status: err.status,
        url: err.url,
        name: ApiEndpointType.submitTaxWithholdings,
        message: err.error[0].Detail,
        hasError: !err.ok
      },
    };
  }),
);